import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type3NumberTable } from "./type3Number.table";

@Component({
  selector: "spec-app-type3-number-list-window",
  templateUrl: "./type3Number.list.html",
  styleUrls: ["./type3Number.list.scss"]
})
export class Type3NumberListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type3NumberTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type3NumberPage",
      this.tab.system,
      (object) => `Type3Number at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type3NumberList reload");
    super.reload();
    this.table.refreshList();
  }
}
